import { LocalDate } from 'src/core/common/domain/date/local-date';
import { Task, TaskPrimitives } from 'src/core/master-data/domain/task';
import { UuidGenerator } from '../../../common/infrastructure/uuid/uuid-generator';
import { TaskQueueElement } from './task-queue-element';
import { QueueElementError, QueueElementType } from '../queue-element';

type CreateTaskQueueElementPrimitives = {
  id: string;
  expected_date: string;
  created_at: string;
  type: string;
  task: TaskPrimitives;
  operation_status: {
    isCreatedToServer: boolean;
  };
  errors: Array<QueueElementError>;
};

export class CreateTaskQueueElement extends TaskQueueElement {
  constructor(
    id: string,
    public expectedDate: LocalDate,
    createdAt: LocalDate,
    public task: Task,
    public operationStatus: {
      isCreatedToServer: boolean;
    },
    public errors: Array<QueueElementError>
  ) {
    super(id, createdAt, QueueElementType.CREATE);
    this.label = this.task.subject;
    this.publicId = this.task.id;
  }

  static fromPayload(payload: CreateTaskQueueElementPrimitives) {
    return new this(
      payload.id,
      LocalDate.fromIsoString(payload.expected_date),
      LocalDate.fromIsoString(payload.created_at),
      Task.fromPrimitives(payload.task),
      payload.operation_status,
      payload.errors
    );
  }

  static fromTask(task: Task, operationStatus: { isCreatedToServer: boolean }, errors: Array<QueueElementError>) {
    return new this(UuidGenerator.random(), task.date.expected, LocalDate.now(), task, operationStatus, errors);
  }

  toPrimitives(): CreateTaskQueueElementPrimitives {
    return {
      id: this.id,
      type: this.type,
      created_at: this.createdAt.atom,
      expected_date: this.expectedDate.atom,
      task: this.task.toPrimitives(),
      operation_status: this.operationStatus,
      errors: this.errors,
    };
  }

  update(task: Task, operationStatus: { isCreatedToServer: boolean }, errors: Array<QueueElementError>) {
    this.task = task;
    this.operationStatus = operationStatus;
    this.errors = errors;
  }
}
